import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { VueRecaptcha } from "vue-recaptcha";

import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
export default {
  __name: 'Captcha',
  props: {
    modelValue: {
      type: String,
      "default": ""
    }
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var VUE_APP_SITEKEY = process.env.VUE_APP_SITEKEY;
    var value = useVModel(props, "modelValue", emit);
    var recaptchaRef = ref(null);
    var isReset = ref(true);
    var isLoaded = ref(false);
    function onVerify(response) {
      value.value = response;
      isReset.value = false;
    }
    function onError() {
      value.value = "";
      if (!isReset.value) {
        recaptchaRef.value.reset();
      }
    }
    function onRender() {
      isLoaded.value = true;
    }
    watch(value, function () {
      if (value.value === "") {
        recaptchaRef.value.reset();
      }
    });
    return function (_ctx, _cache) {
      var _component_PBSpinner = _resolveComponent("PBSpinner");
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["inline-flex items-center justify-center min-w-[304px] min-h-[78px] rounded-md", {
          'border border-solid border-zinc-700': !_unref(isLoaded)
        }])
      }, [!_unref(isLoaded) ? (_openBlock(), _createBlock(_component_PBSpinner, {
        key: 0
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(_unref(VueRecaptcha), {
        ref_key: "recaptchaRef",
        ref: recaptchaRef,
        sitekey: _unref(VUE_APP_SITEKEY),
        theme: "dark",
        onVerify: onVerify,
        onError: onError,
        onRender: onRender
      }, null, 8, ["sitekey"]), [[_vShow, _unref(isLoaded)]])], 2);
    };
  }
};